const {
    REACT_APP_API_URL = "http://localhost:4400/graphql",
    REACT_APP_SERVICE_API_URL = "http://localhost:4400",
    REACT_APP_SOCKET_URL = "ws://localhost:4400/graphql",
    REACT_APP_ENV = "development",
    REACT_APP_AZURE_CLIENT_ID = "c40b72eb-17ab-4328-896c-a554a93ca654",
    REACT_APP_AZURE_TENANT_ID = "4df928c2-c873-43b0-8bbc-f5a208d1e556",
    REACT_APP_MINIO_OBJECT_END_POINT="http://13.127.144.184:9000/",
    REACT_APP_CHAT_API_URL = "http://localhost:5000",
    REACT_APP_ASK_FLASHDICE_API_ENDPOINT = "http://localhost:4400/v1/chat/completions",
    REACT_APP_MAX_NODES = 15,
    REACT_APP_OPENAI_BASE_URL = "https://vllm.flashdice.dev.sntechlabs.com/v1",
    REACT_APP_WORKFLOW_CHAT_API_URL = "http://localhost:4400/v1/chat/ai-assistant",
    REACT_APP_WORKFLOW_CHAT_MODEL = "gpt-4o-mini",
  } = process.env;
  
  export const ENV = {
    api_url: REACT_APP_API_URL,
    socket_url: REACT_APP_SOCKET_URL,
    environment: REACT_APP_ENV,
    service_url: REACT_APP_SERVICE_API_URL,
    minio_bucket_url: REACT_APP_MINIO_OBJECT_END_POINT,
    chat_api_url: REACT_APP_CHAT_API_URL,
    azure: {
      clientId: REACT_APP_AZURE_CLIENT_ID,
      tenantId: REACT_APP_AZURE_TENANT_ID,
    },
    ask_flashdice_api_endpoint: REACT_APP_ASK_FLASHDICE_API_ENDPOINT,
    max_nodes: REACT_APP_MAX_NODES,
    openai_base_url: REACT_APP_OPENAI_BASE_URL,
    workflow_chat_api_url: REACT_APP_WORKFLOW_CHAT_API_URL,
    workflow_chat_model: REACT_APP_WORKFLOW_CHAT_MODEL,
  };
  